import { useWallet } from "@solana/wallet-adapter-react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import Dashboard from "./dashboard";
import Main from "./main";
import Presale from "./presale";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const Inner = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/presale" element={<Presale />} />
        <Route path="/" element={<Dashboard />}></Route>
      </Routes>
    </BrowserRouter>
  );
};

export const Page = () => {
  const { publicKey } = useWallet();

  return (
    <>
      <header>
        <div className="header__fixed">
          <div className="logotype">
            <a href="#">Forge</a>
          </div>
          <div className="nav__row">
            <a href="#" className="x"></a>
            <a href="#" className="telegram"></a>
            <a href="#" className="eagle"></a>
            <WalletMultiButton className="connect-button">
              {!publicKey ? "Connect wallet" : ""}
            </WalletMultiButton>
          </div>
        </div>
      </header>
      {publicKey && <Inner />}

      {!publicKey && <Main></Main>}
    </>
  );
};

export default Page;
